module.exports = __webpack_public_path__ + "img/red1.2ca9d08b.jpg";